var frozen = {};
var frozenTestMap = new Map();
if (typeof Object.freeze === 'function') {
    Object.freeze(frozen);
}
try {
    frozenTestMap.set(frozen, frozen).delete(frozen);
}
catch (_a) {
    var wrap = function (method) {
        return method && (function (obj) {
            try {
                frozenTestMap.set(obj, obj).delete(obj);
            }
            finally {
                return method.call(Object, obj);
            }
        });
    };
    Object.freeze = wrap(Object.freeze);
    Object.seal = wrap(Object.seal);
    Object.preventExtensions = wrap(Object.preventExtensions);
}
//# sourceMappingURL=fixPolyfills.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-cache-inmemory/lib/fixPolyfills.js
// module id = 2383
// module chunks = 0